















































import { Component, Mixins } from 'vue-property-decorator'
import { IColumnDef } from '@/interfaces/ag-grid'
import { TrackFields } from '@/constants'
import { LibraryMixin } from '@/mixins'
import { Track } from '@/classes/track'
import { timeout } from '@/helpers/generic'
import { USAGE_STAT_FEATURES } from '@/system/usage-stats'
import { waitForMinimumDelay, toDateStringSafe } from '@/helpers/date'
import { spawn, Thread, Worker } from 'threads'
import { ARTISTTITLE_SEPARATOR_CODE, ARTISTTITLE_SEPARATOR_DEFAULT, TRACKMATCHING_METHODS } from '@/store/modules/trackmatching'

@Component({
  components: {
    ReorderTable: require('@/components/ReorderTable').default,
    ProgressLoader: require('@/components/ProgressLoader').default,
    SpotifyPlaylistSaveModal: require('@/components/SpotifyPlaylistSaveModal').default,
    CopyTextModal: require('@/components/CopyTextModal').default,
    PlaylistSaveModal: require('@/components/PlaylistSaveModal').default
  }
})
export default class Result extends Mixins(LibraryMixin) {
  tracks: Track[] = []
  selectedTracks: Track[] = []
  loading: boolean = false
  loadingMatches: boolean = false
  playlistName: string = this.$store.state.trackmatching.playlistPrefix + `Tracks Matched ${toDateStringSafe(new Date())}`
  linesWithoutResult: string[] = []
  unmatchedSpotifyTrackIds: string[] = []

  columnDefs: IColumnDef[] = [
    {
      field: TrackFields.Title
    },
    {
      field: TrackFields.Artist
    }
  ]

  get parsedLines(): string[][] {
    return this.$store.state.trackmatching.parsedLines
  }

  get lines(): string[] {
    return this.$store.state.trackmatching.lines
  }

  get disabled(): boolean {
    return this.selectedTracks.length === 0 || !this.playlistName
  }

  get linesWithoutResultText(): string {
    return this.linesWithoutResult
      .filter(x => !!x)
      .join('\n')
      .replace(new RegExp(ARTISTTITLE_SEPARATOR_CODE, 'g'), ARTISTTITLE_SEPARATOR_DEFAULT)
  }

  get trackmatchingMethod(): TRACKMATCHING_METHODS {
    return this.$store.state.trackmatching.method
  }

  back() {
    this.$router.go(-1)
  }

  showLinesWithoutResultModal() {
    ; (this.$refs.copyTextModal as any).openModal()

    window.addUsageStat(USAGE_STAT_FEATURES.TrackMatching, 'open unmatched lines modal')
  }

  openSpotifySaveModal() {
    const lines: {
      artist: string
      title: string
    }[] = this.linesWithoutResult
      .filter(x => !!x && typeof x === 'string')
      .map(x => {
        const s = x.split(` ${ARTISTTITLE_SEPARATOR_CODE} `)

        return {
          artist: s[0],
          title: s[1]
        }
      })

    const trackIds: string[] = lines
      .map(x => this.$store.state.trackmatching.originalData.find(d => d.artist === x.artist && d.title === x.title))
      .filter(x => !!x)
      .map(x => x.trackId)

    this.unmatchedSpotifyTrackIds = trackIds;

    (this.$refs.spotifySaveModal as any).open()
  }

  async onSave() {
    this.$store.commit('trackmatching/reset')

    window.addUsageStat(USAGE_STAT_FEATURES.TrackMatching, 'confirm')

    await this.$router.push({
      name: 'trackmatching choice'
    })
  }

  async created() {
    if (!this.library || this.parsedLines.length === 0) {
      await this.$router.replace({
        name: 'trackmatching choice'
      })

      return
    }

    this.loadingMatches = true

    const startTime = new Date()

    await timeout(100)

    const worker = await spawn(new Worker('@/helpers/features/trackmatching'))

    const result = await worker.findMatchingTracks(this.parsedLines, this.lines, this.library.tracks, this.$store.state.trackmatching.fuzzySearch)

    this.tracks = result.tracks
    this.linesWithoutResult = result.linesWithoutResult

    await Thread.terminate(worker)

    await waitForMinimumDelay(startTime, 500)

    this.loadingMatches = false
  }
}
